import React from "react";
import { Map } from "immutable";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { properCase } from "LIB/formatters/text";
import { COMPANY } from "MODULES/companies/constants";
import { ID, RETURN_TO } from "APP_ROOT/constants";
import api from "APP_ROOT/api";
import { PART_COST } from "MODULES/RepairOrders/constants";
import Form from "./ShippingForm";

export default class EditShipping extends React.Component {
  state = {
    addresses: []
  };
  componentDidMount() {
    api.companies.physicalAddresses
      .search(this.props.record.getIn([COMPANY, ID]), {
        page: 1,
        limit: 100,
        sort: "primary",
        reverse: true
      })
      .then(({ data: { results } }) => {
        this.setState({ addresses: results });
      });
  }

  renderReturnToDiscrepancyWarning() {
    if (
      this.props.returnToDiscrepancy &&
      this.props.shippingType === RETURN_TO
    ) {
      return (
        <div className="col-md-12">
          <div className="alert alert-warning">
            <i className="fa fa-warning" />
            &nbsp;&nbsp; One or more Line Items in this RO do not have the same
            Return details. Changing the Return Shipping Address details on this
            form, will update Return details on all underlying Line Items.
          </div>
        </div>
      );
    }

    return null;
  }

  render() {
    const { open, close, record, shippingType } = this.props;
    const { addresses } = this.state;
    const initialValues = {
      ...record.toJS(),
      cost: record.get(PART_COST), // hack for insurance values
      quantity: 1
    };

    const shippingMethod = record.get(`${shippingType}_shipping_method`);

    if (shippingMethod) {
      initialValues[`${shippingType}_shipping_method`] = shippingMethod.toJS();

      initialValues[`${shippingType}_type`] = record.get(
        `${shippingType}_type`
      );
      initialValues[`${shippingType}_company_address_id`] = record.get(
        `${shippingType}_company_address_id`
      );
      initialValues[`${shippingType}_company_id`] = record.get(
        `${shippingType}_type`
      );
    }

    return (
      <Modal open={open} close={close}>
        <Header>
          <Close close={close} />
          <h4 className="modal-title">
            Edit {properCase(shippingType)} Shipping Info
          </h4>
        </Header>
        {this.renderReturnToDiscrepancyWarning()}
        <Form
          close={close}
          addresses={addresses}
          initialValues={initialValues}
          record={record}
          shippingType={shippingType}
          enableReinitialize
        />
      </Modal>
    );
  }
}

EditShipping.propTypes = {
  close: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  record: PropTypes.instanceOf(Map).isRequired,
  shippingType: PropTypes.string.isRequired,
  returnToDiscrepancy: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Edit/EditShipping.jsx